import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { AlertService } from '../../shared/services/alert.service';
import { FileSaverService } from '../../shared/services/file-saver.service';
import { LoadingWrapperService } from '../../shared/services/loading-wrapper.service';
import { ReportingService } from '../services/reporting.service';
import { CapacityReportFormGroup } from './capacity-report-form.formgroup';

@Component({
    selector: 'app-capacity-report-form',
    templateUrl: './capacity-report-form.component.html'
})

export class CapacityReportFormComponent {
    public rootForm: CapacityReportFormGroup;

    public get plantingDateRangeFormControl(): FormControl {
        return this.rootForm.plantingDateRangeFormControl;
    }

    public get plantingDateRange(): Date[] {
        return this.rootForm.plantingDateRange;
    }

    public get plantingStartDate(): Date {
        return this.rootForm.plantingStartDate;
    }

    public get plantingEndDate(): Date {
        return this.rootForm.plantingEndDate;
    }

    constructor(
        private loadingService: LoadingWrapperService, 
        private alertService: AlertService,
        private reportingService: ReportingService,
        private reportWriterService: FileSaverService
    ) { 
        this.rootForm = new CapacityReportFormGroup();
    }

    public generateReport(): void {
        this.loadingService.setMessage('Generating capacity report...');
    
        this.reportingService.getCapacityReport({
            plantingStartDate: this.plantingStartDate,
            plantingEndDate: this.plantingEndDate,
        })      
        .pipe(finalize(() => this.loadingService.clearMessage()))
        .subscribe(
          file => this.reportWriterService.save(file), 
          _error => this.alertService.error('Error generating capacity report.')
        );
    }
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/reporting/capacity-report-form/capacity-report-form.component.ts